export const stringsKey = "ResponseMapWidget";
export const englishStrings = {
	mapResponseHeader: "Map Response",
	addNewResponseTooltip: "Add New Response",
	requestVoiceNoteLabel: "Request a voice note",
	deleteResponseTooltip: "Delete Response",
	comparisonLabel: "Comparison",
	comparisonValueLabel: "Comparison Value",
	variableValueLabel: "Variable Value",
	comparisonErrorMessage: "The comparison field is required.",
	comparisonValueErrorMessage: "The comparison value field is required.",
	variableValueErrorMessage: "The variable value field is required.",
	typeUSSDInfo: "Only 1 digit numeric value (0-9) is allowed.",
	typeVoiceInfo: "Only 1 digit numeric value (0-9), * and # are allowed.",
	typeSMSInfo: "Only alphabets, numeric value and space( ) are allowed.",
	commaSeparatedMessage: "Enter value separated by comma (,)",
};
